import { PATHNAME_CHECKER } from "../../analytics/LocationTrackingUtils.js";
import { useState, useEffect } from "react";
const usePageContext = () => {
  const [currentPathname, setCurrentPathname] = useState(
    typeof window !== "undefined" ? window.location.pathname : "/"
  );
  useEffect(() => {
    const updatePathname = () => setCurrentPathname(window.location.pathname);
    window.addEventListener("popstate", updatePathname);
    const intervalId = setInterval(() => {
      if (window.location.pathname !== currentPathname) {
        updatePathname();
      }
    }, 100);
    setCurrentPathname(window.location.pathname);
    return () => {
      window.removeEventListener("popstate", updatePathname);
      clearInterval(intervalId);
    };
  }, [currentPathname]);
  const pdpMatch = PATHNAME_CHECKER.isPDP(currentPathname);
  const pPattern = /\/p\/([^/]+)\/product/i;
  const pMatchResult = currentPathname.match(pPattern);
  if (pdpMatch || pMatchResult) {
    const pdpPattern = /^\/pdp\/([^/]+)/i;
    const pdpMatchResult = currentPathname.match(pdpPattern);
    const stacklineSku = (pdpMatchResult == null ? void 0 : pdpMatchResult[1]) || (pMatchResult == null ? void 0 : pMatchResult[1]);
    if (stacklineSku) {
      return {
        pageType: "pdp",
        stacklineSku
      };
    }
  }
  if (PATHNAME_CHECKER.isBrandPage(currentPathname)) {
    return {
      pageType: "brand"
    };
  }
  if (PATHNAME_CHECKER.isBrandclubPage(currentPathname)) {
    return {
      pageType: "brandclub"
    };
  }
  return {
    pageType: "other"
  };
};
export {
  usePageContext
};
//# sourceMappingURL=usePageContext.js.map
